module.exports = __webpack_public_path__ + "static/media/back.9e3dc787.svg";